"use strict";
const moment = require('moment');
function convertToSeconds(value, unit) {
    let multiplier = 1;
    if (unit === 'm') {
        multiplier = 60;
    }
    else if (unit === 'h') {
        multiplier = 3600;
    }
    return value * multiplier;
}
function deserializeCidrDimension(dim, cidrMetrics = []) {
    if (dim.indexOf('_cidr') >= 0) {
        const prefix = cidrMetrics.find((m) => dim.startsWith(m));
        if (prefix) {
            return prefix;
        }
    }
    return dim;
}
function getAlertSuppressionStartTime(startTime) {
    if (startTime !== null) {
        // The API interprets null startTime as "ASAP" and will set the appropriate start time for us.
        // Instead of bugging the user to select the perfect start time, we null it if it's close to now.
        const minStartTime = moment.utc().add(20, 'minutes');
        const userStartTime = moment.utc(startTime);
        if (userStartTime.isBefore(minStartTime)) {
            return null;
        }
    }
    return startTime;
}
module.exports = {
    convertToSeconds,
    deserializeCidrDimension,
    getAlertSuppressionStartTime
};
